export default __webpack_public_path__ + "static/media/aKozlekedesiAnomaliakFeloldasa.b302fcfc.png";